'use client'

import { NewPlatformModal } from '@/components/new-platform-modal'
import { useNewPlatformModal } from '@/hooks/use-new-platform-modal'

export function NewPlatformModalProvider() {
  const { shouldShowModal, closeModal } = useNewPlatformModal()

  return <NewPlatformModal isOpen={shouldShowModal} onClose={closeModal} />
}
